module.exports = __webpack_public_path__ + "img/zongjie.4b7450f0.svg";